export const formatPhoneNumber = (phoneNumber) => {
    return phoneNumber.replace(/[A-Za-z]/g, "")
}